<template>
  <div class="page-content">
    <div class="card-wrap">
      <div
          class="card-item"
          v-for="card in cards"
          :key="card.id"
      >
        <!-- 背景卡片图片 -->
        <el-image
            :src="card.bgImg"
            :preview-src-list="[card.bgImg1]"
            fit="cover"
            class="image-preview"
            :style="{ cursor: 'zoom-in',height: '330px',
    width: '330px' }"
        >
        </el-image>
        <!-- hover 时出现的二维码层 -->
        <div class="card-qr">
          <img class="qr-img" :src="card.qrImg" alt="二维码">
          <p class="qr-tip">微信扫一扫</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopingHome",
  data () {
    return {
      cards: [
        {
          id: 1,
          title: '火爆预售',
          bgImg: require('@/assets/images/shop/hbys-02.jpg'),
          qrImg: require('@/assets/images/shop/qcode.png'),
          bgImg1: require('@/assets/images/shop/hbys-2.jpg'),
        },
        {
          id: 3,
          title: '当季热卖',
          bgImg: require('@/assets/images/shop/djrm-02.jpg'),
          qrImg: require('@/assets/images/shop/qcode.png'),
          bgImg1: require('@/assets/images/shop/djrm-2.jpg'),
        },
        {
          id: 4,
          title: '大都精选',
          bgImg: require('@/assets/images/shop/ddjx-02.jpg'),
          qrImg: require('@/assets/images/shop/qcode.png'),
          bgImg1: require('@/assets/images/shop/ddjx-2.jpg'),
        },
        {
          id: 2,
          title: '精品热卖',
          bgImg: require('@/assets/images/shop/jprm-02.jpg'),
          qrImg: require('@/assets/images/shop/qcode.png'),
          bgImg1: require('@/assets/images/shop/jprm-2.jpg'),
        },
      ]
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.page-content{
  min-height: calc(100vh - 116px);
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
}
.card-wrap {
  background-color: #ffffff;
  width: 1260px;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 10px;
  display: flex;
  gap: 60px;
  min-height: calc(100vh - 116px);
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  padding-left: 100px;
  padding-right: 100px;
}

.card-item {
  position: relative;
  width: 330px;
  height: 330px;
  border-radius: 10px;
  cursor: pointer;
}

/* 背景图 */
.card-bg {
  width: 100%;
  height: 100%;
  display: block;
}

/* 二维码遮罩层，默认隐藏 */
/*.card-qr {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .35); !* 半透明黑背景 *!
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  opacity: 0;
  transition: opacity .3s;
}*/

/* 二维码遮罩层，默认隐藏 */
.card-qr {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .35);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  opacity: 0;
  transition: opacity .3s;

  /* 让遮罩层不拦截鼠标事件，点击穿透到下面的 el-image */
  pointer-events: none;
}

/* hover 时显示二维码 */
.card-item:hover .card-qr {
  opacity: 1;
}

.qr-img {
  width: 240px;
  height: 240px;
}

.qr-tip {
  margin-top: 10px;
  color: #fff;
}
</style>
